const angular = require('angular');
var app = angular.module('learn-controllers');
const moment = require('moment');

app.directive('assignmentCalendar', [
  'Application', 
  'Authorization',
  'Assignments',
  'UserWorkshops',
  '$translate',
  '$q',
  function (Application, Authorization, Assignments, UserWorkshops, $translate, $q) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        selected: '=',
      },
      template: require('../../templates/directives/assignment-calendar.html'),
      controller: [
        '$scope',
        function ($scope) {
          var self = this;
          self.authtoken = Authorization.getAuthToken();
          self.user = self.authtoken.user;
          self.futureWorkshops = [];
          self.pastWorkshops = [];
          var guessedTz = moment.tz.guess();

          self.initialize = function () {
            $q.all([
              Assignments.find({
                assignee: self.user._id,
                fields:
                  'assignee,completed,completed_date,completed_content,assigner,article,media,track,quiz,scorm,imported_content,assessment,createdAt,assigned_content.content_id,assigned_content.content_type,due_date',
                sort: 'createdAt,-1',
                'article-populate': 'title,content,banner_image,archived',
                'media-populate': 'title,type,description,image,archived',
                'scorm-populate': 'title,description,banner_image,archived',
                'imported_content-populate': 'title,description,banner_image,archived',
                'assessment-populate': 'title,description,archived',
                'track-populate': 'name,description,banner_image,archived',
                'quiz-populate': 'title,description,banner_image,archived',
                'assigned_content.content_id-populate': 'title,name,description,banner_image,archived,type,image',
              }).$promise,
              UserWorkshops.find({
                user: self.user._id,
                fields: 'user,active_status,workshop,workshop_instance',
                'workshop-populate': 'title,image,banner_image',
                'workshop_instance-populate': 'title,start_date,end_date,location,online,online_location,online_location_label,recordings',
              }).$promise,
            ])
              .then(function (results) {
                self.assignments = self.parseAndSet(results[0]);
                self.workshops = self.parseUserWorkshops(results[1]);
                self.selected = removeTime(moment());
                self.month = self.selected.clone();

                var start = self.selected.clone();
                start.date(1);

                removeTime(start.day(0));
                buildMonth(self, start, self.month);
              })
              .catch(function (error) {
                console.log('Error: ', error);
              });
          };
          self.initialize();

          self.dateFormat = function (location, type, instance) {
            if (!instance.start_date) {
              return '';
            }
            if (location === 'top') {
              if (type === 'month') {
                return moment(new Date(instance.start_date).valueOf()).tz(guessedTz).format('MMM');
              }
              if (type === 'day') {
                return moment(new Date(instance.start_date).valueOf()).tz(guessedTz).format('D');
              }
            }
            if (location === 'mid-full') {
              if (type === 'date') {
                return moment(new Date(instance.start_date).valueOf()).tz(guessedTz).format('MMM D, YYYY');
              }
              if (type === 'time') {
                if (!self.multiDate) {
                  return moment(new Date(instance.start_date).valueOf()).tz(guessedTz).format('h:mma') + ' - ' + moment(new Date(instance.end_date).valueOf()).tz(guessedTz).format('h:mma z');
                }
                return moment(new Date(instance.start_date).valueOf()).tz(guessedTz).format('h:mma z') + ' to';
              }
            }
            if (location === 'mid-full-end') {
              if (type === 'date') {
                return moment(new Date(instance.end_date).valueOf()).tz(guessedTz).format('MMM D, YYYY');
              }
              if (type === 'time') {
                return moment(new Date(instance.end_date).valueOf()).tz(guessedTz).format('h:mma z');
              }
            }
          };

          // Navigation functions
          self.goTo = function (link) {
            Application.navigation.goTo(link);
          };

          self.goToWorkshop = function (id) {
            Application.navigation.goTo('/view/workshops/' + id);
          };

          // Calendar functions
          self.next = function () {
            var next = self.month.clone();
            removeTime(next.month(next.month() + 1).date(1));
            self.month.month(self.month.month() + 1);
            buildMonth(self, next, self.month);
          };

          self.previous = function () {
            var previous = self.month.clone();
            removeTime(previous.month(previous.month() - 1).date(1));
            self.month.month(self.month.month() - 1);
            buildMonth(self, previous, self.month);
          };

          self.select = function (day) {
            self.currentDayAssignments = [];
            self.currentDayWorkshops = [];

            if (day.assignmentsDue.length === 0 && day.hasWorkshop.length === 0) {
              return;
            } else {
              self.currentDayAssignments = day.assignmentsDue;
              self.currentDayWorkshops = day.hasWorkshop;
              self.showModal = true;
            }
          };

          function removeTime(date) {
            return date.day(0).hour(0).minute(0).second(0).millisecond(0);
          }

          function buildMonth(self, start, month) {
            self.weeks = [];

            var done = false,
              date = start.clone(),
              monthIndex = date.month(),
              count = 0;

            while (!done) {
              self.weeks.push({ days: buildWeek(date.clone(), month) });
              date.add(1, 'w');
              done = count++ > 2 && monthIndex !== date.month();
              monthIndex = date.month();
            }
          }

          function buildWeek(date, month) {
            var days = [];

            for (var i = 0; i < 7; i++) {
              const number = date.date();
              const currentMonth = date.month() + 1;
              const year = date.year();
              const currentDateStr = `${year}-${currentMonth}-${number}`;

              const assignmentsDue = self.assignments.open.filter((assignment) => moment(assignment.due_date).format('YYYY-M-D') == currentDateStr);

              const hasWorkshop = self.futureWorkshops.filter((workshop) => moment(workshop.workshop_instance.start_date).format('YYYY-M-D') == currentDateStr);

              days.push({
                name: date.format('dd').substring(0, 1),
                number: number,
                month: currentMonth,
                year: year,
                isCurrentMonth: currentMonth === month.month() + 1,
                isToday: date.isSame(new Date(), 'day'),
                date: date,
                assignmentsDue: assignmentsDue,
                hasWorkshop: hasWorkshop,
              });
              date = date.clone();
              date.add(1, 'd');
            }
            return days;
          }

          self.getDays = function (item, type) {
            var now = moment();
            var due;

            if (type === 'workshop') {
              due = (item.start_date && moment(item.start_date)) || null;
            } else {
              due = (item.due_date && moment(item.due_date)) || null;
            }

            if (!due || due.valueOf() < now.valueOf()) {
              return null;
            }
            return Math.ceil(moment.duration(due.diff(now)).asDays());
          };

          // Handle Assignments
          var typeMap = {
            scorm: 'scorm',
            track: 'tracks',
            workshop: 'workshops',
            article: 'articles',
            video: 'videos',
            file: 'files',
            assessment: 'assessments',
            imported_content: 'imported-content',
            multi_session_workshop: 'multi-session-workshops',
          };

          self.parseAndSet = function (items) {
            var completed = [];
            var open = [];
            angular.forEach(items, function (assignment) {
              assignment.item = {
                title: null,
                link: '#/',
                type: null,
                due_in: self.getDays(assignment),
              };

              if (!assignment.due_date) return;

              if (assignment.due_date && !assignment.completed_date) {
                if (new Date(assignment.due_date) < new Date()) {
                  assignment.item.overdue = true;
                }
              }

              assignment.titles = [];
              var item = {};

              if (assignment.assigned_content && assignment.assigned_content.length) {
                assignment.assigned_content.forEach(function (item) {
                  var content = item.content_id;
                  if (!content) {
                    return;
                  }
                  if (content.archived) {
                    return;
                  }
                  var completed = [];
                  if (assignment.completed_content && assignment.completed_content.length) {
                    completed = assignment.completed_content.map(function (item) {
                      return item.content_id;
                    });
                  }
                  assignment.titles.push({
                    title: content.title || content.name || 'Untitled',
                    type: content.type,
                    link: '/view/' + typeMap[content.type] + '/' + content._id,
                    description: content.description || content.content,
                    image: content.banner_image || content.image,
                    completed: completed.indexOf(content._id) !== -1,
                  });
                });
              }

              if (assignment.article) {
                if (assignment.article.archived) {
                  return;
                }
                item.title = assignment.article.title;
                item.type = 'article';
                item.description = assignment.article.content;
                item.link = '/view/articles/' + assignment.article._id;
                item.image = assignment.article.banner_image;
                assignment.titles.push(item);
              }
              if (assignment.media) {
                if (assignment.media.archived) {
                  return;
                }
                item.title = assignment.media.title;
                item.type = assignment.media.type;
                item.description = assignment.media.description;
                item.link = '/view/' + assignment.media.type + 's/' + assignment.media._id;
                item.image = assignment.media.image;
                assignment.titles.push(item);
              }
              if (assignment.quiz) {
                if (assignment.quiz.archived) {
                  return;
                }
                item.title = assignment.quiz.title;
                item.type = 'quiz';
                item.description = assignment.quiz.description;
                item.link = '/view/quizzes/' + assignment.quiz._id;
                item.image = assignment.quiz.banner_image;
                assignment.titles.push(item);
              }
              if (assignment.scorm) {
                if (assignment.scorm.archived) {
                  return;
                }
                item.title = assignment.scorm.title;
                item.type = 'title';
                item.description = assignment.scorm.description;
                item.link = '/view/scorm/' + assignment.scorm._id;
                item.image = assignment.scorm.banner_image;
                assignment.titles.push(item);
              }
              if (assignment.imported_content) {
                if (assignment.imported_content.archived) {
                  return;
                }
                item.title = assignment.imported_content.title;
                item.type = 'title';
                item.description = assignment.imported_content.description;
                item.link = '/view/imported-content/' + assignment.imported_content._id;
                item.image = assignment.imported_content.banner_image;
                assignment.titles.push(item);
              }
              if (assignment.assessment) {
                if (assignment.assessment.archived) {
                  return;
                }
                item.title = assignment.assessment.title;
                item.type = 'assessment';
                item.description = assignment.assessment.description;
                item.link = '/view/assessments/' + assignment.assessment._id;
                assignment.titles.push(item);
              }
              if (assignment.track) {
                if (assignment.track.archived) {
                  return;
                }
                item.title = assignment.track.name;
                item.type = 'track';
                item.description = assignment.track.description;
                item.link = '/view/tracks/' + assignment.track._id;
                item.image = assignment.track.banner_image;
                assignment.titles.push(item);
              }

              if (assignment.completed) {
                assignment.formattedDate = '--';
                if (assignment.completed_date) {
                  assignment.completed_date = new Date(assignment.completed_date);
                  var formatted = moment(assignment.completed_date).format('MMMM Do, YYYY');
                  $translate('dashboard.assignments.completedDate', { value: formatted }).then(function (data) {
                    assignment.formattedDate = data;
                  });
                  assignment.formattedDateShort = moment(assignment.completed_date).format('MMM YYYY');
                }
                completed.push(assignment);
                return;
              }
              open.push(assignment);
            });

            return {
              completed: completed,
              open: open,
            };
          };

          // Handle Workshops
          self.parseUserWorkshops = function (data) {
            data.sort(function (a, b) {
              if (!a.workshop_instance || !a.workshop_instance.start_date || !b.workshop_instance || !b.workshop_instance.start_date) {
                return 0;
              }
              if (new Date(a.workshop_instance.start_date) < new Date(b.workshop_instance.start_date)) {
                return 1;
              }
              if (new Date(a.workshop_instance.start_date) > new Date(b.workshop_instance.start_date)) {
                return -1;
              }
              return 0;
            });
            data.forEach(function (item) {
              if (item.active_status === 'attended') {
                self.pastWorkshops.push(item);
                return;
              }
              if (item.active_status === 'registered') {
                var start = (item.workshop_instance && item.workshop_instance.start_date) || null;
                if (start && new Date(start) < new Date()) {
                  self.pastWorkshops.push(item);
                  return;
                }
                item.due_in = self.getDays(item.workshop_instance, 'workshop');
                self.futureWorkshops.unshift(item);
              }
            });
          };
        },
      ],
      controllerAs: 'calendar',
    };
  },
]);
